import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable()
export class LoginInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const isSolicitarMfaUrl = request.url.includes('/solicitar-mfa');
    const isHml = environment.environmentName === 'HML';
    if (isSolicitarMfaUrl && isHml) {
      request = request.clone({
        setHeaders: {
          'X-Client-Token': environment.recaptcha.notValidateKey
        }
      });
    }
    return next.handle(request);
  }
}
